const maximumSizeMb = 8;
export const acceptedTypesDescription = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
export const extendedAcceptedFileTypes = [
  ...acceptedTypesDescription,
  'text/csv',
  'application/csv',
  'text/plain',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/rtf',
  'text/rtf',
  'application/vnd.ms-excel',
  'application/octet-stream'
];

export const UPDLOAD_FILE_IMAGE_ACCEPTED_TYPES = ['image/jpeg', 'image/png', 'image/gif'];

export const UPLOAD_FILE_CSV_ACCEPTED_TYPES = [
  '.csv',
  'text/csv',
  'application/csv',
  'text/comma-separated-values'
] as const;

export const UPLOAD_FILE_CONFIG = {
  acceptedTypes: acceptedTypesDescription,
  extendedAcceptedFileTypes: extendedAcceptedFileTypes,
  maximumSize: maximumSizeMb
};
